var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Component from "../lib/component";
import html from "./toast.html";
import "./toast.scss";
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        var _this = _super.call(this, "toast", html, { singleInstance: true }) || this;
        window.toast = _this;
        return _this;
    }
    MyComponent.prototype.init = function () {
        this.messageDiv = this.container.children.item(0);
    };
    MyComponent.prototype.show = function (message, seconds) {
        var _this = this;
        if (seconds === void 0) { seconds = 3; }
        this.messageDiv.innerHTML = message;
        this.container.classList.add("show");
        setTimeout(function () { return _this.container.classList.remove("show"); }, seconds * 1000);
    };
    return MyComponent;
}(Component));
export default new MyComponent();
